import React, { useState, useEffect, memo, useRef } from 'react';
import PropTypes from 'prop-types';
import { PostContentContainer } from './PinnedPostCard.styled';
import getContentSummary from '../../../../../../../../core/utils/getContentSummary';
import uuid from '../../../../../../../../core/utils/uuid';

const MAX_CARD_HEIGHT = 136;

const PostContent = memo(({ content }) => {
  const [contentSummary, setContentSummary] = useState([]);
  const [height, setHeight] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    setContentSummary(getContentSummary({ content, allBlocks: true }));
  }, [content]);

  useEffect(() => {
    if (ref.current) {
      setHeight(ref.current.clientHeight);
    }
  }, [ref.current]);

  return (
    <PostContentContainer innerRef={ref}>
      {contentSummary.map((postContent) =>
        postContent ? (
          <span key={uuid()} className="post-content">
            {postContent}
          </span>
        ) : (
          <span key={uuid()} className="post-content empty" />
        )
      )}
      {height >= MAX_CARD_HEIGHT && <div className="fade" />}
    </PostContentContainer>
  );
});

PostContent.propTypes = {
  content: PropTypes.string.isRequired,
};

export default PostContent;
